
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TemplateService {

    constructor(
        public _httpClient: HttpClient
    ) { }

    generatePdf(context: object, config: any): Observable<any> {
        const opt = {
            headers: new HttpHeaders({ "Content-Type": "application/json", "Accept": "application/pdf" }),
            responseType: 'blob' as 'blob'
        };    

        const body = {
            context: context,
            config: config
        };
        return this._httpClient.post("api/pdftemplate/inline/pdf", body, opt);
    }

    generatePdfFromHtml(document: string, context: object, pdfOptions: any): Observable<any> {
        const opt = {
            headers: new HttpHeaders({ "Content-Type": "application/json", "Accept": "application/pdf" }),
            responseType: 'blob' as 'blob'
        };

        const body = {
            context: context,
            config: {
                pdfDocument: document,
                pdfOptions: pdfOptions
            }
        };

        return this._httpClient.post("api/pdftemplate/inline/pdf", body, opt);
    }

    getHtml(template: string, context: object, fileName: string): Observable<string> {


        var body = {
            htmlTemplate: template,
            context: context,
            templateFile: fileName
        };

        var options = {
            responseType: 'text'
        } as any;

        return this._httpClient.post<string>('api/pdftemplate/inline/html', body, options) as any;
    }

    loadHtmlTemplate(templateName: string): Observable<any> {
        var options = {
            responseType: 'text'
        } as any;

        return this._httpClient.get(`api/pdfTemplate/getHtmlTemplate/${templateName}`, options);
    }

    saveHtmlTemplate(template: string, fileName: string, pdfOptions: any): Observable<any> {
        var body = {
            htmlTemplate: template,
            context: {},
            options: pdfOptions,
            templateFile: fileName
        };
        return this._httpClient.post("api/pdfTemplate/saveHtmlTemplate", body);
    }

    generateAreaOfReviewMapPdf(context: object, config: any): Observable<any> {
        const opt = {
            headers: new HttpHeaders({ "Content-Type": "application/json", "Accept": "application/pdf" }),
            responseType: 'blob' as 'blob'
        };    

        const body = {
            context: context,
            config: config
        };
        return this._httpClient.post("api/pdftemplate/inline/aormappdf", body, opt);
    }
}
